import auction from "./auction";
import banners from "./banners";
import boards from "./boards";
import center from "./center";
import fairs from "./fairs";
import forms from "./forms";
import me from "./me";
import lawyers from "./lawyers";
import media from "./media";
import message from "./message";
import setting from "./setting";
import practice from "./practice";
import shop from "./shop";
import terms from "./terms";
import users from "./users";
import popups from "./popups";
import * as pansim from "./pansim";

export default {
    auction,
    banners,
    boards,
    center,
    fairs,
    forms,
    me,
    lawyers,
    message,
    media,
    setting,
    practice,
    shop,
    terms,
    users,
    popups,
    ...pansim,
};
